<template>
    <div class="header" id="app-header">
      <!-- 通用头部 -->
      <div class="container">
        <div class="title">{{event.eventName || ''}}</div>
        <div class="mine">
          <div class="user">
            <img @click="showInfo" class="user_head" v-if="!!photoUrl" :src="photoUrl" alt="">
            <img @click="showInfo" class="user_head" v-if="!photoUrl" src="../assets/images/head.png" alt="">
            <span @click="showInfo" class="name">{{name || ''}}</span>
            <span class="line">|</span>
            <span class="train" @click="toCourse">我的培训</span>
          </div>
          <div class="menu" v-show="showMenu">
            <img class="menu_bg" src="../assets/images/header_userbg.png" alt="">
            <div class="list" @click="changeInfo">
              <img style="width: 0.2rem;height: 0.21rem;" src="../assets/images/header_user.png" alt="">
              <span>修改资料</span>
            </div>
            <div class="list" @click="changePassword">
              <img style="width: 0.17rem;height: 0.21rem;" src="../assets/images/header_password.png" alt="">
              <span>修改密码</span>
            </div>
            <div class="list" @click="logout">
              <img style="width: 0.18rem;height: 0.18rem;" src="../assets/images/header_exit.png" alt="">
              <span>退出登录</span>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  export default {
    name: 'app-header',
    data () {
      return {
         showMenu:false,
         userinfo:'',
         name:false,
         photoUrl:false,
         event:false,
      }
    },
    mounted() {
      var _this = this;
      var interVal = setInterval(function(){
        _this.event = JSON.parse(localStorage.getItem('event'));
        if(_this.event){
          clearInterval(interVal);
        }
      },200)
      setInterval(function(){
        var userinfo = JSON.parse(localStorage.getItem('userinfo'));
        // console.log(userinfo);
        if(userinfo){
          _this.userinfo = userinfo;
          _this.photoUrl = userinfo.photoUrl;
          _this.name = userinfo.name;
        }
      },300)

    },
    methods:{
      toCourse(){
        this.$router.replace({path:'/Achieve'}); // 页面加载时跳转
      },
      showInfo(){
        this.showMenu = !this.showMenu;
      },
      changeInfo(){
        this.$router.push({name:'Userinfo',query:{type:1}});
      },
      changePassword(){
        this.$router.push({name:'Userinfo',query:{type:2}});
      },
      logout(){
        var _this = this;
        _this.$router.replace('/login');
        localStorage.clear();
        this.post('/sys/logout',{},(data)=>{})
      },
    }
  }
</script>
<style scoped>
.header{
  width: 100%;
}
.container{
  width: 100%;
  height: 1.14rem;
  margin: 0 auto;
  background-color: #2b73cc;
}
.title{
  float: left;
  font-size: 0.3rem;
  color: #fff;
  height: 0.5rem;
  line-height: 0.5rem;
  margin-top: 0.5rem;
  margin-left: 0.37rem;
}
.mine{
  width: 3rem;
  height: 0.5rem;
  line-height: 0.5rem;
  float: right;
  margin-top: 0.5rem;
  margin-right: 0.4rem;
  position: relative;
}
.mine .user{
  font-size: 0.25rem;
  color: #fff;
  cursor: pointer;
}
.mine .user .train{
  float: right;
}
.mine .user .line{
  float: right;
  margin: 0 0.2rem;
}
.mine .user .name{
  float: right;
  margin-right: 0.1rem;
}
.mine .user .user_head{
  width: 0.5rem;
  height: 0.5rem;
  float: right;
  border-radius: 50%;
}


.mine .menu{
  width: 1.63rem;
  height: 1.58rem;
  position: absolute;
  top: 0.6rem;
  right: 0.4rem;
  padding-top: .37rem;
}
.mine .menu .menu_bg{
  width: 1.63rem;
  height: 1.58rem;
  position: absolute;
  top: 0;
  left: 0;
}
.mine .menu .list{
  width: 100%;
  height: 0.21rem;
  line-height: 0.22rem;
  text-align: center;
  position: relative;
  margin-bottom: 0.21rem;
  cursor: pointer;
}
.mine .menu .list img{
  float: left;
  margin-left: 0.25rem;
}
.mine .menu .list span{
  float: left;
  font-size: 0.21rem;
  color: #404040;
  margin-left: 0.1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue